import { SVGProps, Ref, forwardRef } from 'react';

export const HeartOutlinedSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="m16 12.965-1.966-2.806C11.631 6.728 8.606 6.016 6.406 6.57 4.166 7.137 2.4 9.07 2.4 11.936c0 2.204 1.582 4.6 4.651 7.2 2.628 2.227 5.893 4.23 8.949 6.066 3.056-1.836 6.321-3.84 8.949-6.065 3.07-2.6 4.651-4.997 4.651-7.2 0-2.623-1.727-4.603-4.04-5.223-2.22-.595-5.217.05-7.594 3.445zM16 28C9.333 24 0 18.603 0 11.936c0-7.31 8.503-10.83 14.408-5.044q.837.817 1.592 1.89a13 13 0 0 1 1.596-1.885C23.5 1.17 32 4.996 32 11.937 32 18.602 22.667 24 16 28"
                fill="currentColor"
            />
        </g>
    </svg>
));
HeartOutlinedSize32Glyph.displayName = 'HeartOutlinedSize32Glyph';
